export const PHONE_NUMBER_REGEX = /^[6-9]\d{0,9}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/